<div class="modal-header" appCustomAutofocus>
        <h3 class="modal-title">Confirm Cash-Out Request</h3>
    </div>
    <div class="modal-body">
        You are requesting to cash out {{cashHours}} hours for the pay period ending on {{payPeriod}}.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-success" (click)="submitClicked()">
            Submit
        </button>
        <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">
            Cancel
        </button>
    </div>